import React, { useState, useEffect, useCallback } from 'react';
import { withCookies } from 'react-cookie';
import * as styles from './CookiesPopup.module.scss';

const IS_COOKIES_ACCEPTED = 'isCookiesAccepted';

const CookiesPopup = ({ cookies }) => {
  const [isClosed, setClosed] = useState(false);

  useEffect(() => {
    setClosed(
      cookies.get(IS_COOKIES_ACCEPTED) !== undefined ?
        cookies.get(IS_COOKIES_ACCEPTED) :
        false
    )
  }, []);

  const closePopup = useCallback(
    () => {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);
      cookies.set(IS_COOKIES_ACCEPTED, true, { path: '/', expires });
      setClosed(true);
    },
    [],
  );

  if (isClosed) {
    return null;
  }

  return (
    <div className={styles.cookiesPopupWrapper}>
      <div className={styles.cookiesPopup}>
        <div className={styles.cookiesText}>
            <span>
                This site uses cookies to improve user experience.
                By using our services you agree to our use of cookies.
            </span>
          {' '}
          <a href='https://flatfy.com/cookies' target="_blank" rel="noopener noreferrer">
            + Info
          </a>
        </div>
        <button
          className={styles.cookiesCloseBtn}
          onClick={closePopup}
        >
          Ok
        </button>
      </div>
    </div>
  )
};

export default withCookies(CookiesPopup);
